

/*
    firstname	
    middlename	
    lastname	
    prefix
    suffix
    credentials
    jobTitle
    address1	
    address2	
    city	
    state	regionId
    zip	
    zipext	
    phoneForDisplay	
    phonextn	
    faxForDisplay	
    emailaddress	
    confirmemailaddress	
    verifiedByUser	
*/
import { textInputDataReducer } from 'Components/Forms/FormReducers/TextInputReducer';
import { phoneInputDataReducer } from 'Components/Forms/FormReducers/PhoneInputReducer';
import { radioInputDataReducer } from 'Components/Forms/FormReducers/RadioInputReducer';
import { selectInputDataReducer } from 'Components/Forms/FormReducers/SelectInputReducer';
import { dateInputDataReducer } from 'Components/Forms/FormReducers/DateInputReducer';
import { checkboxInputDataReducer } from 'Components/Forms/FormReducers/CheckboxInputReducer';

import {useEffect, useReducer, useState, useRef } from "react";
import { ORG_TYPES, STATUSES, TextInputObj, DEFAULT_TEXT_INPUT,FORM_ACTION_TYPES } from "Utils/constants";


var getVarValue = function(value){
    if(typeof value === 'function'){
        return value();
    }
    else{
        return value;
    }
};


var disabledOnTest = {
    "Edit": [],
    "Create": [],
    "View": []
};

var getDisabledOn = function(disableOnFormActionOrgTypes, currentFormActionType, orgType){
    var display = false;
    Object.keys(disableOnFormActionOrgTypes).map(type => {
        if(type.toLowerCase() == currentFormActionType.toLowerCase()){
            display=true;
            disableOnFormActionOrgTypes[type].forEach(oT => {
                if(oT!=null && oT.length>0){
                    if(oT.text.toLowerCase() == orgType.toLowerCase()){
                        display=true;
                    } 
                }
                
            });
        }
    })
    return display;
};

var getReadOnlyOn = function(readOnlyOnFormActionOrgTypes, currentFormActionType, orgType){
    var readOnly = false;
    Object.keys(readOnlyOnFormActionOrgTypes).map(type => {
        if(type.toLowerCase() == currentFormActionType.toLowerCase()){
            readOnly=true;
            readOnlyOnFormActionOrgTypes[type].forEach(oT => {
                if(oT!=null && oT.length>0){
                    if(oT.text.toLowerCase() == orgType.toLowerCase()){
                        readOnly=true;
                    }
                }
            });
        }
    });
    return readOnly;
};

var getNotRequiredOnlyOn = function(requiredOnlyOnFormActionOrgTypes, currentFormActionType, orgType){
    var required = true;
    Object.keys(requiredOnlyOnFormActionOrgTypes).map(type => {
        if(type.toLowerCase() == currentFormActionType.toLowerCase()){
            required=false;
            requiredOnlyOnFormActionOrgTypes[type].forEach(oT => {
                if(oT!=null && oT.length>0){
                    if(oT.text.toLowerCase() == orgType.toLowerCase()){
                        required=true;
                    }
                }
                
            });
        }
    });
    return required;
};

export function GetTextInputObj ({id,name,value,label,description,title,placeholder,required, isInvalid,errors,isValid, successMsgs,disabled,readOnly,hideFieldOrgTypes}) {
    var textInputObj = {
        type: 'text',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, textInputObj );
}

export function GetPhoneInputObj ({id,name,value,label,description,title,placeholder,required, isInvalid,errors,isValid, successMsgs,disabled,readOnly,hideFieldOrgTypes}) {
    var phoneInputObj = {
        type: 'tel',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(phoneInputDataReducer, phoneInputObj );
}

export function GetRadioInputObj ({id,name,value,radioButtons,label,description,title,placeholder,required, isInvalid,errors,isValid, successMsgs,disabled,readOnly,hideFieldOrgTypes}) {
    var radioInputObj = {
        type: 'radio',
        id: id,
        name: name,
        value: value,
        radioButtons: radioButtons,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(radioInputDataReducer, radioInputObj );
}

export function GetCheckboxInputObj ({id,name,value, checkBoxes, label,description,title,placeholder,required, isInvalid,errors,isValid, successMsgs,disabled,readOnly,hideFieldOrgTypes}) {
    var checkInputObj = {
        type: 'checkbox',
        id: id,
        name: name,
        value: value,
        checkBoxes: checkBoxes,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(checkboxInputDataReducer, checkInputObj );
}


export function GetSelectInputObj ({id,name,value, options,label,description,title,placeholder,required, isInvalid,errors,isValid, successMsgs,disabled,readOnly,hideFieldOrgTypes}) {
    var selectInputObj = {
        type: 'select',
        id: id,
        name: name,
        value: value,
        options: options,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(selectInputDataReducer, selectInputObj );
}

export function GetDateInputObj ({id,name,value,label,description,title,placeholder,required, isInvalid,errors,isValid, successMsgs,disabled,readOnly,hideFieldOrgTypes}) {
    var dateInputObj = {
        type: 'date',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(dateInputDataReducer, dateInputObj );
}

/*
    password

*/

export function GetTextInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        case "name":
            return GetTextInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Organization Name',
                description: 'Organization name maximum length: 80',
                title: "Enter an Organization's Name. Maximum number of characters allow for this field is 80 characters.",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: []
            });
        case "psoId":
            return GetTextInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Organization ID',
                description: function () {
                    //console.log(orgType);
                    if(orgType.toLowerCase()=="PSO".toLowerCase()){
                        return "Letter 'P' followed by four numeric digit (i.e, P0000)";
                    }
                    else if(orgType.toLowerCase()=="Vendor".toLowerCase()){
                        return "Letter 'V' followed by four numeric digit (i.e, V0000)";
                    }
                    else{
                        return null;
                    }
                },
                title: "Enter Organization's ID. Example of a PSO ID: P0001 and Example of a Vendor ID: V0000",
                placeholder: "",
                required: getNotRequiredOnlyOn({"Create":[ORG_TYPES.Admin],"View":[ORG_TYPES.Admin],"Edit":[ORG_TYPES.Admin]},formActionType, orgType), //CREATE: not required if admin
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"Create":[ORG_TYPES.Admin], "View":[]},formActionType, orgType),
                readOnly: getReadOnlyOn({"Create":[ORG_TYPES.Admin],"View":[]},formActionType,orgType), //CREATE: readonly if admin
                hideFieldOrgTypes: []
            });
        case "website":
            return GetTextInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Organization Website URL',
                description: '',
                title: "Enter Organization's website URL",
                placeholder: "",
                required: false,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: []
            });
        case "address1":
            return GetTextInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Address Line 1',
                description: '',
                title: "Enter Street Address",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: []
            });
        case "address2":
            return GetTextInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Address Line 2',
                description: '',
                title: "Enter Street Address. This field can be used to enter extra street address",
                placeholder: "",
                required: false,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: []
            });
        case "city":
            return GetTextInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'City',
                description: '',
                title: "Enter City name",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: []
            });
        case "zip":
            return GetTextInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Zip Code',
                description: '',
                title: "Enter Zip code as 5 digits.",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: []
            });
        case "zipExtension":
            return GetTextInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Zip Extension',
                description: '',
                title: "Enter 4 digits Zip extension if any",
                placeholder: "",
                required: false,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: []
            });
        case "extension":
            return GetTextInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Phone Number Extension',
                description: '(i.e 1234)',
                title: "Enter Phone Number extension if any. Example: 1234",
                placeholder: "",
                required: false,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: []
            });
    }
    
}


export function GetSelectInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        case "regionId":
            return GetSelectInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                options: [],
                label: 'State',
                description: '',
                title: "",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: []
            });
    }
}


export function GetPhoneInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        
        case "phone":
            return GetPhoneInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Phone Number',
                description: '(###) ###-####',
                title: "Enter Phone Number as 10 digits. Example: (123) 456-7890",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: []
            });

        case "fax":
            return GetPhoneInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Fax Number',
                description: '(###) ###-####',
                title: "Enter Fax Number as 10 digits. Example: (123) 456-7890",
                placeholder: "",
                required: false,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: []
            });
    }
}


export function GetRadioInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        case "statusId":
            return GetRadioInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                radioButtons:[],
                label: 'Status',
                description: '',
                title: "",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: []
            });
        case "testOrg":
            return GetRadioInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                radioButtons: [
                    {
                        id: "0",
                        label: "Yes",
                        name: "orgIsTest",
                        value: "Yes",
                        title: "Is Test Organization",
                        isChecked: false,//dets.testOrg=="Yes" ? true : false,
                        //onChange: handleRadioChange,
                        //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                    },
                    {
                        id: "1",
                        label: "No",
                        name: "orgIsTest",
                        value: "No",
                        title: "Is Not Test Organization",
                        isChecked: false,//dets.testOrg=="No" ? true : false,
                        //onChange: handleRadioChange,
                        //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                    }
                ],
                label: 'Test Organization',
                description: '',
                title: "",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: ["admin"]
            });
    }
}


export function GetDateInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        case "agreementEffectiveDate":
            return GetDateInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Effective Date',
                description: '',
                title: "",
                placeholder: "",
                required: false,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: ["vendor","admin"]
            });
        case "listingEffectiveDate":
            return GetDateInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Listing Date',
                description: '',
                title: "",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: ["vendor","admin"]
            });
        case "agreementEndDate":
            return GetDateInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'End Date',
                description: '',
                title: "",
                placeholder: "",
                required: false,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: ["vendor","admin"]
            });
        case "listingEndDate":
            return GetDateInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'De-listing Date',
                description: '',
                title: "",
                placeholder: "",
                required: false,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: getDisabledOn({"View":[]},formActionType,orgType),
                readOnly: getReadOnlyOn({"View":[]},formActionType,orgType),
                hideFieldOrgTypes: ["vendor","admin"]
            });
    }
}

export function GetCheckboxInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        
    }
}